import { useCallback, useEffect, useRef } from 'react';

export const useDebouncedDateSearch = (onSearch: (date: Date | null) => void) => {
  const searchRef = useRef(onSearch);
  const timeoutRef = useRef<ReturnType<typeof setTimeout>>();

  searchRef.current = onSearch;

  const cancelDateSearch = useCallback(() => {
    clearTimeout(timeoutRef.current);
  }, []);

  useEffect(() => cancelDateSearch, [cancelDateSearch]);

  const debounceDateSearch = useCallback(
    (date: Date | null, valid = true) => {
      cancelDateSearch();
      if (valid && (!date || Number.isFinite(date.getTime()))) {
        timeoutRef.current = setTimeout(() => searchRef.current(date), 400);
      }
    },
    [cancelDateSearch]
  );

  return { debounceDateSearch, cancelDateSearch };
};
